/* Store Availability Accordion */
window.addEventListener("load", () => {
  const storeAvailabilityContainer = document.querySelector("#inventory-info-app");
  const storeAvailabilityContent = storeAvailabilityContainer?.querySelector(
    "#inventory-info-app .iia-details-container"
  );
  const storeAvailabilityAccordion = document.querySelector(
    ".accordion__content.store-availability"
  );
  if (storeAvailabilityContent && storeAvailabilityAccordion) {
    storeAvailabilityAccordion.appendChild(storeAvailabilityContent);
    storeAvailabilityContainer?.remove();
  }
});
/* Store Availability Accordion */

// /* Swym Product Page button */

// const swymObserver = new MutationObserver((mutations) => {
//   mutations.forEach((mutation) => {
//     mutation.addedNodes.forEach((node) => {
//       if (node.nodeType === Node.ELEMENT_NODE) {
//         if (node.classList && node.classList.contains("swym-atw-btn-wrapper-for-img")) {
//           const mainProductTitle = document.querySelector(
//             '.product .product-info__block-item[data-block-type="title"]'
//           );
//           if (mainProductTitle && !mainProductTitle.contains(node)) {
//             const existingButton = mainProductTitle.querySelector(".swym-atw-btn-wrapper-for-img");
//             if (existingButton) {
//               existingButton.remove();
//             }
//             mainProductTitle.appendChild(node);
//           }
//         }
//       }
//     });
//   });
// });

// swymObserver.observe(document.body, {
//   childList: true,
//   subtree: true,
// });

// /* Swym Product Page button */

/* Photoswipe Arrows */

function setTopBarWidth() {
  const topBar = document.querySelector(".pswp__top-bar");
  const activeItem = document.querySelector(".pswp__item[aria-hidden='false']");
  const activeImg = activeItem
    ? activeItem.querySelector(".pswp__img:not(.pswp__img--placeholder)")
    : null;

  if (topBar && activeImg) {
    const imgWidth = activeImg.offsetWidth;
    const screenWidth = window.innerWidth;

    const baseWidth = imgWidth > screenWidth ? screenWidth : imgWidth;
    const newWidth = baseWidth - 30;

    const closeButton = topBar.querySelector('button[aria-label="Close gallery"]');
    if (closeButton) {
      const halfImageHeight = activeImg.offsetHeight / 2;
      const screenHeight = window.innerHeight;
      const maxTranslateY = screenHeight / 2 - 15;
      if (halfImageHeight > maxTranslateY) {
        closeButton.style.transform = `translateY(-${maxTranslateY}px)`;
      } else {
        closeButton.style.transform = `translateY(-${halfImageHeight - 15}px)`;
      }
    }

    if (topBar.offsetWidth === newWidth) {
      return;
    }
    topBar.style.width = `${newWidth}px`;
  }
}

function debounce(func, wait) {
  let timeout;
  return function executedFunction(...args) {
    const later = () => {
      clearTimeout(timeout);
      func(...args);
    };
    clearTimeout(timeout);
    timeout = setTimeout(later, wait);
  };
}

const debouncedSetTopBarWidth = debounce(setTopBarWidth, 30);

const resizeObserver = new ResizeObserver((entries) => {
  entries.forEach((entry) => {
    if (
      entry.target.classList.contains("pswp__img") &&
      !entry.target.classList.contains("pswp__img--placeholder")
    ) {
      debouncedSetTopBarWidth();
    }
  });
});

const transformObserver = new MutationObserver((mutations) => {
  mutations.forEach((mutation) => {
    if (mutation.type === "attributes" && mutation.attributeName === "style") {
      const target = mutation.target;
      if (
        target.classList &&
        (target.classList.contains("pswp__zoom-wrap") ||
          (target.classList.contains("pswp__img") &&
            !target.classList.contains("pswp__img--placeholder")))
      ) {
        debouncedSetTopBarWidth();
      }
    }
  });
});

const activeItemObserver = new MutationObserver((mutations) => {
  mutations.forEach((mutation) => {
    if (mutation.type === "attributes" && mutation.attributeName === "aria-hidden") {
      const target = mutation.target;
      if (
        target.classList.contains("pswp__item") &&
        target.getAttribute("aria-hidden") === "false"
      ) {
        debouncedSetTopBarWidth();
      }
    }
  });
});

const photoSwipeObserver = new MutationObserver((mutations) => {
  mutations.forEach((mutation) => {
    mutation.addedNodes.forEach((node) => {
      if (node.nodeType === Node.ELEMENT_NODE) {
        if (
          node.classList &&
          node.classList.contains("pswp__img") &&
          !node.classList.contains("pswp__img--placeholder")
        ) {
          resizeObserver.observe(node);
          transformObserver.observe(node, {
            attributes: true,
            attributeFilter: ["style"],
          });
          debouncedSetTopBarWidth();
        }

        const zoomWraps = node.querySelectorAll ? node.querySelectorAll(".pswp__zoom-wrap") : [];
        zoomWraps.forEach((wrap) => {
          transformObserver.observe(wrap, {
            attributes: true,
            attributeFilter: ["style"],
          });
        });
      }
    });

    mutation.removedNodes.forEach((node) => {
      if (node.nodeType === Node.ELEMENT_NODE) {
        if (
          node.classList &&
          node.classList.contains("pswp__img") &&
          !node.classList.contains("pswp__img--placeholder")
        ) {
          resizeObserver.unobserve(node);
        }
      }
    });
  });
});

photoSwipeObserver.observe(document.body, {
  childList: true,
  subtree: true,
});

activeItemObserver.observe(document.body, {
  attributes: true,
  attributeFilter: ["aria-hidden"],
  subtree: true,
});

window.addEventListener("resize", debouncedSetTopBarWidth);

document.addEventListener("DOMContentLoaded", () => {
  const existingImgs = document.querySelectorAll(".pswp__img:not(.pswp__img--placeholder)");
  existingImgs.forEach((img) => {
    resizeObserver.observe(img);
    transformObserver.observe(img, {
      attributes: true,
      attributeFilter: ["style"],
    });
  });

  const existingZoomWraps = document.querySelectorAll(".pswp__zoom-wrap");
  existingZoomWraps.forEach((wrap) => {
    transformObserver.observe(wrap, {
      attributes: true,
      attributeFilter: ["style"],
    });
  });

  setTopBarWidth();
});

/* Photoswipe Arrows */
